// src/supabaseClient.ts
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

/**
 * ✅ CRA ONLY (Create React App)
 * Usa variables REACT_APP_*
 *
 * En Vercel/CI, cualquier warning rompe el build,
 * y CRA no tolera import.meta en el bundle.
 */
const supabaseUrl = String(process.env.REACT_APP_SUPABASE_URL || "").trim();
const supabaseAnonKey = String(process.env.REACT_APP_SUPABASE_ANON_KEY || "").trim();

/**
 * ✅ Producción-friendly:
 * - En DEV: lanza error para que lo notes ya
 * - En PROD: log fuerte, pero evita pantalla blanca
 */
const missing: string[] = [];
if (!supabaseUrl) missing.push("REACT_APP_SUPABASE_URL");
if (!supabaseAnonKey) missing.push("REACT_APP_SUPABASE_ANON_KEY");

if (missing.length > 0) {
  const msg = `Faltan variables de entorno de Supabase: ${missing.join(", ")}`;

  // CRA expone NODE_ENV
  if (process.env.NODE_ENV !== "production") {
    throw new Error(msg);
  } else {
    console.error(msg);
  }
}

/**
 * ✅ Cliente Supabase
 * - persistSession: guarda sesión en localStorage
 * - autoRefreshToken: refresca token automáticamente
 * - detectSessionInUrl: útil para magic links / confirm email / OAuth
 */
export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});



